import React, { useEffect, useState } from 'react';
import BDEHeader from './BDEHeader';
import BarWidget from './BarWidget';
import { gaugeMetrics, revenueProfitMetrics } from '../../config/pageConfig';
import { Select, DatePicker } from 'antd';
import DashboardStats from './DashboardStats';
import dayjs, { Dayjs } from 'dayjs';
import { getData } from '../../../../../../actions/apiCall';
import { useDispatch } from 'react-redux';

// const employeeOptions = [{ value: 'sarah_lee', label: 'Sarah Lee' }];
const periodOptions = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' }
];
const { RangePicker } = DatePicker;

const DashboardLayout: React.FC = () => {
    const [startDate, setStartDate] = useState<Dayjs | null>(null);
    const [employees, setEmployees] = useState<any[]>([]);
  const [employeeOptions, setEmployeeOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    getEmployees();
  }, []);

  const getEmployees = async () => {
    const res = await dispatch(getData('/users'));

    if (res?.data) {
      setEmployees(res.data);

      const options = res.data.map((item: any) => ({
        value: item._id, // ✅ always use id
        label: `${item.firstName} ${item.lastName}`,
      }));

      setEmployeeOptions(options);

      // ✅ default selected employee
      setSelectedEmployee(res.data[0]);
    }
  };

    const handleEmployeeChange = (employeeId: string) => {
    const emp = employees.find(e => e._id === employeeId);
    setSelectedEmployee(emp);
  };


     const disabledDate = (current: Dayjs) => {

    if (startDate) {
      return current.isBefore(startDate.startOf('day'));
    }
    return false;
  };
  return (
    <div className=" ">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-gray-800">BDE Details</h1>

        <div className="flex space-x-3">
          {/* <Select defaultValue="sarah_lee" options={employeeOptions} style={{ width: 180 }} /> */}
          <Select
          defaultValue="sarah_lee"
  value={selectedEmployee?._id}
  options={employeeOptions}
  style={{ width: 180 }}
  onChange={handleEmployeeChange}
/>
          <Select defaultValue="monthly" options={periodOptions} style={{ width: 140 }} />
          <RangePicker  style={{ width: 220 }}  disabledDate={disabledDate}
            onCalendarChange={(dates) => {
              setStartDate(dates?.[0] || null);
            }} />
        </div>
      </div>

      {/* Top BDE summary */}
      <BDEHeader employee={selectedEmployee} />

      {/* -----------------------------------
           FIXED LAYOUT (1 large + 3 gauge cards)
         ----------------------------------- */}
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 ">

  {/* LEFT COLUMN → Revenue + Profit */}
  <div className="col-span-1 space-y-6">
    {revenueProfitMetrics.map((config) => (
      <BarWidget key={config.title} config={config} />
    ))}
  </div>

  {/* RIGHT 3 COLUMNS → Gauge Cards */}
  <div className="col-span-1 md:col-span-3">
    <DashboardStats />
  </div>
  
</div>

    </div>
  );
};

export default DashboardLayout;
